import React from 'react';

import PropTypes from 'prop-types';

import SignatureField from '../SignatureField';

/**
 * Why didn't I use a functional component here?
 *
 * The unmount functionality with the useEffect doesn't allow me
 * to access the focused and changes state that I needed. Inside
 * of the useEffect cleanup it always showed both these values
 * as undefined.
 *
 */
class TableSignatureField extends React.PureComponent {

	static propTypes = {

		fieldId: PropTypes.string,
		fieldIdentifier: PropTypes.string,
		fieldPositionId: PropTypes.string,

		value: PropTypes.array,
		cellValue: PropTypes.string,
		rowId: PropTypes.string,

		disabled: PropTypes.bool,

		//SDK Styles
		primaryColor: PropTypes.string,

		//Field style
		fontSize: PropTypes.number,
		fontColor: PropTypes.string,
		fontStyle: PropTypes.string,
		fontWeight: PropTypes.string,
		textAlign: PropTypes.string,
		textTransform: PropTypes.string,
		textDecoration: PropTypes.string,
		textOverflow: PropTypes.string,
		borderColor: PropTypes.string,
		borderRadius: PropTypes.number,
		borderWidth: PropTypes.number,
		backgroundColor: PropTypes.string,
		padding: PropTypes.number,
		margin: PropTypes.number,

		//Action handlers
		onChange: PropTypes.func,
		onFocus: PropTypes.func,
		onBlur: PropTypes.func,
		onCapture: PropTypes.func,

	}

	static defaultProps = {
		value: ''
	}

	constructor(props) {
		super(props);
		const { cellValue } = props;
		this.state = { focused: false, changes: cellValue };
	}

	componentDidUpdate(prevProps) {
		const { changes } = this.state;
		const { cellValue } = this.props;
		if (cellValue !== prevProps.cellValue && cellValue !== changes) this.setState({ changes: cellValue });
	}

	componentWillUnmount() {

		const { cellValue, disabled, fieldId, fieldIdentifier, fieldPositionId, rowId, columnIdentifier, column, onBlur } = this.props;
		const { changes, focused } = this.state;

		/**
		 * This ensures that changes are saved when this component unmounts
		 * without first losing focus. The return func in useEffect is the
		 * same as firing cleanup stuff in comoponentWillUnmount.
		 */
		if (focused && changes !== cellValue && !disabled) {

			this.handleCellChange(changes);

			onBlur(fieldId, fieldIdentifier, fieldPositionId, {}, rowId, column, columnIdentifier);
		}

	}

	render() {

		const { focused, changes } = this.state;

		const {
			fieldId,
			fieldIdentifier,
			fieldPositionId,

			rowId,
			column,
			columnIdentifier,

			cellValue,
			disabled,

			//Field style
			primaryColor,
			fontSize,
			fontColor,
			fontStyle,
			fontWeight,
			textAlign,
			textTransform,
			textDecoration,
			textOverflow,
			borderColor,
			borderRadius,
			borderWidth,
			backgroundColor,
			padding,
			margin,

			//Action handlers
			onFocus,
			onBlur,
			onChange,

			calculatedCellValue,
			tableColumns

		} = this.props;

		const targetColumn = tableColumns.find((col) => col._id === column);

		return (
			<SignatureField
				{...{
					primaryColor,
					disabled,
					fontSize,
					fontColor,
					fontStyle,
					fontWeight,
					textAlign,
					textTransform,
					textDecoration,
					textOverflow,
					borderColor,
					borderRadius,
					borderWidth,
					backgroundColor,
					padding,
				}}
				disabled={disabled}
				key={`${fieldPositionId}-table-text-field-calculated`}
				data-testid={`${fieldPositionId}-table-text-field-calculated`}
				value={calculatedCellValue || ''}
				maxImageWidth={targetColumn.maxImageWidth}
				maxImageHeight={targetColumn.maxImageHeight}
				onFocus={(f, i, p, e) => {

					if (!disabled && onFocus) {
						onFocus(fieldId, fieldIdentifier, fieldPositionId, { blur: () => { e.blur(); } }, rowId, column, columnIdentifier);
					}

				}}
				onBlur={(e) => {


					if (onBlur) {

						onBlur(fieldId, fieldIdentifier, fieldPositionId, {}, rowId, column, columnIdentifier);

					}
				}}
				onChange={(f, i, p, value, signer) => {

					this.handleCellChange(value, signer);

				}}

			/>

		)

	}

	handleCellChange = (nextCellValue, signer) => {

		const { onChange, rowId, column, value, fieldId, fieldIdentifier, fieldPositionId } = this.props;

		const nextValue = [...value];

		const targetRowIndex = value.findIndex((row) => row._id === rowId);
		const nextRow = { ...nextValue[targetRowIndex] };

		/**<----------NOTICE---------------->
		 * onChange will only be triggered if the row and column associated
		 * with the table cell is undeleted
		*/
		if (nextRow && nextRow._id) {

			nextRow.cells = { ...nextRow.cells, [column]: nextCellValue };

			nextValue[targetRowIndex] = nextRow;

			if (onChange) onChange(fieldId, fieldIdentifier, fieldPositionId, nextValue, signer);

		}
		else {
			this.setState({ changes: '' });
		}

	}

	handleBarcodeClick = async () => {
		const { onCapture, disabled } = this.props;
		if (disabled) return;
		if (onCapture) {
			const response = await onCapture();
			this.handleCellChange(response);
		}
	};

}

export default TableSignatureField;
